import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IS_BETA, APP_ENV } from '../lib/environment';

/* global __GIT_HASH__ */
const gitHash = typeof __GIT_HASH__ !== 'undefined' ? __GIT_HASH__ : '';

export default function BetaBadge() {
  const navigate = useNavigate();

  if (!IS_BETA) return null;

  const label = APP_ENV === 'staging' ? 'STAGING' : 'DEV';

  return (
    <button
      onClick={() => navigate('/app/admin/control-center')}
      style={{
        position: 'fixed',
        bottom: 86,
        left: 16,
        zIndex: 9990,
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '4px 10px',
        borderRadius: 20,
        background: 'rgba(201, 168, 76, 0.75)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(201, 168, 76, 0.4)',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        letterSpacing: '0.04em',
        cursor: 'pointer',
        lineHeight: 1,
        boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
        transition: 'opacity 0.15s',
      }}
      title="Open Admin Control Center"
    >
      <span style={{
        width: 6, height: 6, borderRadius: '50%',
        background: APP_ENV === 'staging' ? '#fbbf24' : '#34d399',
        flexShrink: 0,
      }} />
      {label}{gitHash ? ` · ${gitHash}` : ''}
    </button>
  );
}
